<template>
  <v-navigation-drawer :value="isDrawerOpen" app floating width="auto" class="app-navigation-menu"
    @input="(val) => $emit('update:is-drawer-open', val)">
    <!-- Navigation Items -->
    <v-list expand shaped class="vertical-nav-menu-items pr-5">
      <!-- Menus principaux -->
      <nav-menu-link v-for="item in menuItems" :key="item.title" :title="item.title" :to="item.to"
        :icon="icons[item.icon]"></nav-menu-link>

      <!-- Groupe Abonnement -->
      <nav-menu-group title="Abonnement" :icon="icons.mdiFileOutline">
        <nav-menu-link v-for="item in abonnementItems" :key="item.title" :title="item.title" :to="item.to"
          :icon="icons[item.icon]"></nav-menu-link>
      </nav-menu-group>

      <!-- Groupe Utilisateurs -->
      <nav-menu-group title="Utilisateurs" :icon="icons.mdiFileOutline">
        <nav-menu-link v-for="item in utilisateursItems" :key="item.title" :title="item.title" :to="item.to"
          :icon="icons[item.icon]"></nav-menu-link>
      </nav-menu-group>

      <!-- Autres liens -->
      <nav-menu-link title="FAQ" :to="{ name: 'Faq' }" :icon="icons.mdiFrequentlyAskedQuestions"></nav-menu-link>
      <nav-menu-link title="Envoi de notifications" :to="{ name: 'notification' }"
        :icon="icons.mdiSend"></nav-menu-link>
      <nav-menu-link title="Statistiques Notifications" :to="{ name: 'Statistique' }"
        :icon="icons.mdiChartBar"></nav-menu-link>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiHomeOutline,
  mdiAlphaTBoxOutline,
  mdiEyeOutline,
  mdiCreditCardOutline,
  mdiTable,
  mdiFileOutline,
  mdiFormSelect,
  mdiAccountCogOutline,
  mdiArchive,
  mdiShapePlus,
  mdiTag,
  mdiCog,
  mdiBook,
  mdiWhiteBalanceSunny,
  mdiAlertBox,
  mdiAlphaSBoxOutline,
  mdiFrequentlyAskedQuestions,
  mdiChartBar,
  mdiSend,
  mdiClockOutline,
} from "@mdi/js";
import NavMenuSectionTitle from "./components/NavMenuSectionTitle.vue";
import NavMenuGroup from "./components/NavMenuGroup.vue";
import NavMenuLink from "./components/NavMenuLink.vue";

export default {
  components: {
    NavMenuSectionTitle,
    NavMenuGroup,
    NavMenuLink,
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      menuItems: [
        { title: "Verset", to: { name: "Verset" }, icon: "mdiShapePlus" },
        {
          title: "List Sous Verset",
          to: { name: "SousVersetList" },
          icon: "mdiShapePlus",
        },
        {
          title: "Verset Sous Theme",
          to: { name: "VersetGroupe" },
          icon: "mdiShapePlus",
        },
        { title: "Surat", to: { name: "Surat" }, icon: "mdiShapePlus" },
        { title: "Juzz", to: { name: "Juzz" }, icon: "mdiShapePlus" },
        { title: "Hizb", to: { name: "Hizb" }, icon: "mdiShapePlus" },
        { title: "Theme", to: { name: "Theme" }, icon: "mdiWhiteBalanceSunny" },
        {
          title: "Sous Theme",
          to: { name: "SousTheme" },
          icon: "mdiWhiteBalanceSunny",
        },
        { title: "Duaa", to: { name: "duaa" }, icon: "mdiWhiteBalanceSunny" },
        {
          title: "Sous duaa ",
          to: { name: "SousDuaa" },
          icon: "mdiWhiteBalanceSunny",
        },
        {
          title: "Recitateur",
          to: { name: "Recitateur" },
          icon: "mdiWhiteBalanceSunny",
        },
        {
          title: "Categorie",
          to: { name: "Category" },
          icon: "mdiWhiteBalanceSunny",
        },
        {
          title: "Serie",
          to: { name: "SubCategory" },
          icon: "mdiWhiteBalanceSunny",
        },
        {
          title: "Tag",
          to: { name: "Tag" },
          icon: "mdiWhiteBalanceSunny",
        },
        {
          title: "Articles",
          to: { name: "Actuality" },
          icon: "mdiWhiteBalanceSunny",
        },
        {
          title: "Auteur",
          to: { name: "Author" },
          icon: "mdiWhiteBalanceSunny",
        },
        {
          title: "Expert",
          to: { name: "Expert" },
          icon: "mdiWhiteBalanceSunny",
        },
        {
          title: "Slider",
          to: { name: "Personalise" },
          icon: "mdiBook",
        },
        {
          title: "Podcast",
          to: { name: "Podcast" },
          icon: "mdiBook",
        },
        {
          title: "Réclamation",
          to: { name: "Complaint" },
          icon: "mdiAlertBox",
        },
        {
          title: "Paramètres généraux",
          to: { name: "GeneralSettings" },
          icon: "mdiCog",
        },
        {
          title: "Sondage",
          to: { name: "Investigation" },
          icon: "mdiBook",
        },
        {
          title: "Coming Soon",
          to: { name: "ComingSoon" },
          icon: "mdiClockOutline",
        },
      ],
      abonnementItems: [
        {
          title: "type d'abonnement",
          to: { name: "Subscription" },
          icon: "mdiAlphaSBoxOutline",
        },
        {
          title: "Abonnement user",
          to: { name: "subscriptionUsers" },
          icon: "mdiAlphaSBoxOutline",
        },
        {
          title: "QR Code",
          to: { name: "QRCode" },
          icon: "mdiAlphaSBoxOutline",
        },
      ],
      utilisateursItems: [
        {
          title: "Nouvel Administrateur",
          to: { name: "NewUser" },
          icon: "mdiWhiteBalanceSunny",
        },
        {
          title: "Administrateurs",
          to: { name: "Admins" },
          icon: "mdiWhiteBalanceSunny",
        },
        {
          title: "Utilisateurs",
          to: { name: "User" },
          icon: "mdiWhiteBalanceSunny",
        },
      ],
    };
  },
  setup() {
    return {
      icons: {
        mdiHomeOutline,
        mdiAlphaTBoxOutline,
        mdiEyeOutline,
        mdiCreditCardOutline,
        mdiTable,
        mdiFileOutline,
        mdiFormSelect,
        mdiAccountCogOutline,
        mdiArchive,
        mdiShapePlus,
        mdiTag,
        mdiBook,
        mdiCog,
        mdiWhiteBalanceSunny,
        mdiFrequentlyAskedQuestions,
        mdiChartBar,
        mdiAlertBox,
        mdiAlphaSBoxOutline,
        mdiSend,
        mdiClockOutline,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;

  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, "background");
}

.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

// You can remove below style
// Upgrade Banner
.app-navigation-menu {
  .upgrade-banner {
    position: absolute;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
